export default "__VITE_ASSET__BpX3RTr2__"